<script>
  import SvelteTooltip from "svelte-tooltip";
  import { onMount } from "svelte";
  export let question;
  let files = [];
  export let addInitialData;
  export let modifyData;
  export let errors;
  let error = null;

  /* Handle input file changes (Only when files are selected by user) */
  function handleChange(e) {
    files = Array.from(e.target.files);
    renderPrevieImage(files);
  }

  /* Delete file */
  function deleteFile(file) {
    const fileIndex = files.findIndex(
      a => a.name == file.name && a.size == file.size
    );

    files.splice(fileIndex, 1);

    const dt = new DataTransfer();

    for (let file of files) {
      dt.items.add(file);
    }

    let input = document.getElementById("multifile");

    input.files = dt.files;

    files = Array.from(dt.files);

    renderPrevieImage(files);
  }

  /* Render preview image */
  async function renderPrevieImage(files) {
    let filesArray = Array.from(files);
    let newFiles = [];

    for (let i = 0; i < filesArray.length; i++) {
      let f = await getBase64(filesArray[i]);
      const parts = filesArray[i].name.split(".");
      newFiles.push({
        base64: f,
        name: parts[0],
        extension: parts[1]
      });
    }

    error = null;

    modifyData({
      question_uuid: question.uuid,
      files: newFiles
    });

    console.log(newFiles);

    files.forEach((file, i) => {
      const image = /\.(jpe?g|png|gif)$/i.test(file.name);
      var reader = new FileReader();

      reader.onload = function() {
        var output = document.getElementById(`image_${file.name}`);
        output.src = image ? reader.result : "images/no-preview.jpg";
      };

      reader.readAsDataURL(file);
    });
  }

  onMount(async () => {
    addInitialData({
      question_uuid: question.uuid,
      files: []
    });
  });

  function getBase64(file) {
    return new Promise(function(resolve) {
      var reader = new FileReader();
      reader.onloadend = function() {
        resolve(reader.result);
      };
      reader.readAsDataURL(file);
    });
  }

  $: if (errors && errors.length > 0) {
    const findError = errors.find(err => err.uuid === question.uuid);

    if (findError) {
      error = findError;
    }
  }

  function startDownload(url) {
    window.open(url, "Download");
  }
</script>

<style>
  .inputs {
    border-radius: 0px;
    color: #a9a9a9;
  }
  .img-preview {
    height: 100px;
    width: 100px;
    padding: 1px;
    vertical-align: middle;
    border-style: none;
  }
  .remove {
    font-size: 18px;
    display: block;
    color: red;
    cursor: pointer;
  }
  .tooltip-color {
    color: white;
  }
</style>

<div class="px-4">
  <h3 class="text-3 mb-1">
    {question.description}{question.required ? ' *' : ''}
  </h3>
  {#if 'answers' in question}
    <span class="text-2">
      {#if question.answers[0].answer.length > 0}
        {#each question.answers[0].answer as file}
          -
          <a href="#" on:click={startDownload(file.url)}>
            {`${file.name}.${file.extension}`}
          </a>
          <br />
        {/each}
      {:else}
        <span class="font-italic">Sin archivos</span>
      {/if}
    </span>
  {:else}
    <div class="form-group mb-1">
      <input
        id="multifile"
        accept={question.extras ? question.extras.join(',') : ''}
        name="name"
        type="file"
        multiple={true}
        on:change={e => handleChange(e)}
        required={question.required}
        class={`form-control inputs ${error ? 'is-invalid' : ''}`} />
      {#if error}
        <div class="invalid-feedback">{error.errors}</div>
      {/if}

      <div class="row mt-4">
        {#each files as file, i (i)}
          <div class="col-md-2 col-lg-2 mx-2">
            <div class="text-center">
              <div class="tooltip-color">
                <SvelteTooltip
                  tip={`Nombre: ${file.name} - Tamaño: ${(file.size / (1024 * 1024)).toFixed(2)} MB`}
                  color="#4843d2"
                  top>
                  <img
                    src=""
                    id={`image_${file.name}`}
                    alt={file.name}
                    class="img-preview rounded" />
                </SvelteTooltip>
              </div>
              <span class="remove" on:click={() => deleteFile(file)}>
                Eliminar
              </span>
            </div>
          </div>
        {/each}
      </div>
    </div>
  {/if}
</div>
